import tokens from '.';

import './index.scss';

export default tokens;
